import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  setup(__props) {

const error = computed(() => store.getters.error)
const hide = () => store.commit('clearError')

return { __sfc: true,error, hide }
}

})